<template>
  <section class="toolbox-page">
    <section class="hero">
      <div class="hero__content">
        <div class="hero__eyebrow">WE.CIRCULAR</div>

        <h1 class="hero__title">Virtual Toolbox</h1>

        <h2 class="hero__subtitle">
          The one-stop shop for policymakers
        </h2>

        <p class="hero__text">
          The Virtual Toolbox aims to function as a centralized and digital knowledge-sharing online platform mainly for
          policymakers and stakeholders to develop better national strategies for the Danube Region, policy instruments
          for women entrepreneurs to support circular and industry 4.0 and S3 transition. The available information in
          the toolbox focuses on national and regional findings, identified policy measures and good practices from the
          WE.Circular project.
        </p>

        <div class="hero__actions">
          <a href="https://interreg-danube.eu/projects/wecircular/about-us" class="btn btn--primary">
            Get in touch
            <span class="btn__arrow">→</span>
          </a>

          <a href="https://interreg-danube.eu/projects/wecircular" class="btn btn--secondary">
            More information
            <span class="btn__arrow">→</span>
          </a>
        </div>
      </div>
    </section>

    <section id="select-country" class="map-section">
      <h2 class="map-section__title">Select a Country</h2>

      <div class="map-card">
        <CountryMap @select-country="$emit('select-country', $event)" />
      </div>
    </section>
  </section>
</template>

<script>
import CountryMap from '../../components/country-map/CountryMap.vue'

export default {
  name: 'CountryMapSection',
  components: {
    CountryMap
  }
}
</script>

<style scoped>
.toolbox-page {
  width: 100%;
  background: #f5f5f5;
}

.hero {
  width: 100%;
  min-height: 640px;
  display: flex;
  align-items: center;
  background-image: url('../../assets/img/we-circular/main_top.svg');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}

.hero__content {
  width: 100%;
  max-width: 720px;
  padding: 88px 0 88px 82px;
  box-sizing: border-box;
}

.hero__eyebrow {
  margin-bottom: 18px;
  color: #18baa8;
  font-size: 16px;
  line-height: 1.2;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-align: left;
}

.hero__title {
  margin: 0 0 14px;
  font-size: 64px;
  line-height: 1.04;
  font-weight: 800;
  color: #ffffff;
  text-align: left;
}

.hero__subtitle {
  margin: 0 0 26px;
  font-size: 26px;
  line-height: 1.2;
  font-weight: 700;
  color: #ffffff;
  text-align: left;
}

.hero__text {
  max-width: 620px;
  margin: 0 0 34px;
  font-size: 16px;
  line-height: 1.75;
  color: rgba(255, 255, 255, 0.96);
  text-align: left;
}

.hero__actions {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 46px;
  padding: 0 18px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
  transition: all 0.2s ease;
  box-sizing: border-box;
}

.btn__arrow {
  font-size: 14px;
  line-height: 1;
}

.btn--primary {
  background: #003399;
  color: #ffffff;
}

.btn--primary:hover {
  background: #0e6eb6;
}

.btn--secondary {
  border: 1px solid rgba(255, 255, 255, 0.55);
  color: #ffffff;
  background: transparent;
}

.btn--secondary:hover {
  background: rgba(255, 255, 255, 0.08);
}

.map-section {
  padding: 54px 0 36px;
  scroll-margin-top: 90px;
}

.map-section__title {
  margin: 0 0 30px;
  text-align: center;
  color: #003399;
  font-size: 44px;
  line-height: 1.1;
  font-weight: 700;
}

.map-card {
  width: calc(100% - 40px);
  margin: 0 auto;
  background: #d1e1e0;
  box-sizing: border-box;
}

@media (max-width: 1200px) {
  .hero {
    min-height: 560px;
  }

  .hero__content {
    max-width: 640px;
    padding: 64px 0 64px 56px;
  }

  .hero__title {
    font-size: 54px;
  }

  .hero__subtitle {
    font-size: 24px;
  }

  .hero__text {
    font-size: 15px;
  }
}

@media (max-width: 900px) {
  .hero {
    min-height: auto;
    background-position: center center;
  }

  .hero__content {
    max-width: 100%;
    padding: 44px 24px 44px;
  }

  .hero__title {
    font-size: 42px;
  }

  .hero__subtitle {
    font-size: 22px;
    margin-bottom: 22px;
  }

  .hero__text {
    font-size: 15px;
    line-height: 1.65;
  }

  .btn {
    min-width: 150px;
    min-height: 46px;
    font-size: 15px;
  }

  .map-section {
    padding-top: 40px;
  }

  .map-section__title {
    font-size: 34px;
  }

  .map-card {
    width: calc(100% - 24px);
    padding: 16px;
  }
}
</style>
